export enum GroupMarketingPreferenceFormField {
  Email = 'email',
  Post = 'post',
  Telephone = 'telephone',
}
